import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IAuthorizationClass } from './IAuthorizationClass';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthClassLookupService {

  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService) {
  }
  uri = `${environment.apiLocation}/EFClass`;

  public get (): Observable<Array<IAuthorizationClass>> {
    this.log.verbose({ type: 'AuthClassLookupService:get', uri: this.uri });
    return this.http.get<Array<IAuthorizationClass>>(this.uri)
      .pipe(tap(res => this.log.verbose({ type: 'AuthClassLookupService:reponse', res }))
      )
      ;
  }
}
